import styled, { keyframes } from 'styled-components';

const placeHolderShimmer = keyframes`
  from {
    background-position: 100% 0
  }
  to {
    background-position: -100% 0
  }
`;

const Skeleton = styled.div`
  position: ${({ relative }) => (relative ? 'relative' : 'absolute')};
  animation-duration: 1.5s;
  animation-fill-mode: forwards;
  animation-iteration-count: infinite;
  animation-name: ${placeHolderShimmer};
  animation-timing-function: linear;
  background: #f6f7f8;
  background: ${({ dark }) =>
    dark
      ? 'linear-gradient(to right, rgba(160,167,203,0.5) 8%, rgba(160,167,203,0.2) 18%, rgba(160,167,203,0.5) 33%)'
      : 'linear-gradient(to right, #eeeeee 8%, #dddddd 18%, #eeeeee 33%)'};
  background-size: 800px 104px;
`;

export default Skeleton;
